import React from 'react';
import { observer } from 'mobx-react';
import { EmailTemplatesListTemplate } from 'themes/application/email-templates/pages';
import { setCurrentView } from 'core/utils';
import { EmailTemplatesListViewStore } from 'application/email-templates/stores';

@setCurrentView((rootStore) => new EmailTemplatesListViewStore(rootStore), 'emailTemplatesListViewStore')
@observer
class EmailTemplatesList extends React.Component {
    render() {
        return <EmailTemplatesListTemplate {...this.props} />
    }
}

export default EmailTemplatesList;